import React from 'react';
import ChatPanel from '../../components/Chat/ChatPanel';
import { ProviderLayout } from '../../components/layouts';

const ProviderMessages = () => {
  return (
    <ProviderLayout title="Support">
      <div className="-m-4 flex h-[calc(100dvh-115px)] min-h-[520px] sm:-m-5 lg:-m-8">
        <ChatPanel />
      </div>
    </ProviderLayout>
  );
};

export default ProviderMessages;
